module.exports = "/_next/static/images/51aff05cf2f940024a4485f303a7202a-people-smile-at-home-xs@2x.jpg.webp";